<div class="row">
  <div class="col-md-12">
    <div [ngClass]="{ separated: type === 'separated' }" class="file-drop">
      <div class="uni-file-input">
        <ngx-file-drop
          *ngIf="type === 'list' || type === 'separated' ? true : !files.length"
          [accept]="accept"
          [multiple]="multiple"
          [dropZoneLabel]="placeHolder"
          (onFileDrop)="onFileDropped($event)"
          [showBrowseBtn]="true"
        >
          <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
            <div>{{ placeHolder }} <span *ngIf="required" class="required-mark">*</span></div>
            <div style="background-color: transparent; display: flex; justify-content: flex-end; align-items: center">
              <img
                src="assets/ui/forms/file-input/icons/svg/upload-more-files-icon.svg"
                alt="upload-more-files-icon-svg"
                (click)="OpenUploadDocumentsModal(reference)"
                (keypress)="onKeyPressFunc()"
                width="30"
                height="30"
                style="cursor: pointer"
              />
              &nbsp;
              <button
                type="button"
                class="btn btn-info ngx-file-drop__browse-btn"
                (click)="onClickUploadFile(openFileSelector)"
              ></button>
            </div>
          </ng-template>
        </ngx-file-drop>
      </div>

      <div *ngIf="type !== 'separated'; else separated" class="preview-array">
        <ng-container *ngIf="isFiduciary && isFiduciaryRequest">
          <ng-container *ngFor="let file of files">
            <h4 style="font-size: 14px; padding: 5px 10px">
              {{ reference }}&nbsp;
              <span _ngcontent-ijd-c155="" class="span-reference-count">{{ getFilesCountByReference() }}</span>
            </h4>
            <div class="preview-item" [ngClass]="{ 'mt-3': multiple }">
              <div class="file-name">
                <ng-container *ngIf="isImage">
                  <img src="assets/ui/forms/file-input/icons/svg/image-icon.svg" alt="pict-icon-svg" width="25" height="25" />
                </ng-container>
                <ng-container *ngIf="!isImage">
                  <img src="assets/ui/forms/file-input/icons/svg/file-icon.svg" alt="files-icon-svg" width="20" height="20" />
                </ng-container>
                {{ file.name }}
              </div>
              <div class="actions" style="display: flex; justify-content: flex-start; align-items: center; gap: 5px">
                <div style="width: 50px; height: 40px; overflow: hidden">
                  <img
                    [alt]="file.name"
                    (click)="onClickFile(file)"
                    (keypress)="onKeyPressFunc()"
                    *ngIf="isImage"
                    src="{{ file.buffer | imgBuffer }}"
                    class="img-fluid"
                    width="50"
                    height="40"
                    style="cursor: pointer"
                  />
                </div>

                <img
                  src="assets/ui/forms/file-input/icons/svg/upload-more-files-icon.svg"
                  alt="upload-more-files-icon-svg"
                  (click)="OpenUploadDocumentsModal(reference)"
                  (keypress)="onKeyPressFunc()"
                  width="30"
                  height="30"
                  style="cursor: pointer"
                />
                &nbsp;
                <button type="button" class="delete-icon" (click)="removeFile(file)"></button>
              </div>
            </div>

            <ng-container *ngIf="showFileDetails">
              <details class="show-file-details">
                <summary style="margin-top: 10px">
                  <b class="summary-text">
                    Ver detalles
                    <img
                      src="assets/ui/forms/file-input/icons/svg/see-more-icon.svg"
                      alt="see-more-icon-svg"
                      width="18"
                      height="18"
                    />
                    &nbsp;
                    <span class="span-file-size"> {{ getFilesSizeMegaBytes1x1(getFilesByReference()) }} mbs </span>
                  </b>
                </summary>
                <div class="file-details-content" *ngFor="let otherFile of getFilesByReference()">
                  <span><b>Nombre</b>: {{ otherFile.file?.name }}</span>
                  <span><b>Tamaño</b>: {{ GetFileSizeMegaBytes(otherFile.file, 3) }} mbs</span>
                </div>
              </details>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!isFiduciary">
          <div class="preview-item" [ngClass]="{ 'mt-3': multiple }" *ngFor="let file of files">
            <div class="file-name">
              {{ file.name }}
            </div>
            <div class="file-preview" (click)="onClickFile(file)">
              <img [alt]="file.name" src="{{ file.buffer | imgBuffer }}" class="img-fluid" *ngIf="isImage" />
            </div>
            <div class="actions">
              <button type="button" class="delete-icon" (click)="removeFile(file)"></button>
            </div>
          </div>
        </ng-container>
      </div>

      <ng-template #separated>
        <div class="file-example">
          <div>
            <ng-container *ngIf="!files[0]">
              <ng-container *ngTemplateOutlet="fileExample"></ng-container>
            </ng-container>
          </div>

          <div *ngIf="files[0] as file" (click)="onClickFile(file)">
            <img [alt]="file.name" [src]="file.buffer | imgBuffer" class="img-fluid" />
            <button type="button" class="delete-icon" (click)="removeFile(file)"></button>
          </div>
        </div>
      </ng-template>

      <app-info-popover *ngIf="popover" class="file-tooltip" [content]="popover" [breakLine]="false"> </app-info-popover>
    </div>
  </div>
</div>
